import { Component, Input, EventEmitter, OnChanges, Output, SimpleChanges, inject } from '@angular/core';
import { ModalFormContainerComponent } from '../../ui/modal-form-container/modal-form-container.component';
import { ITag } from '../../../types/contactModule';
import { ContactsService } from '../../../services/contacts/contacts.service';
import { GroupPickerComponent } from '../../organization/contacts/group-picker/group-picker.component';

/** Picks tags for a contact form; the form saves them with the contact. */
@Component({
  selector: 'assign-tags-modal',
  standalone: true,
  imports: [ModalFormContainerComponent, GroupPickerComponent],
  templateUrl: './assign-tags-modal.component.html',
  styleUrls: [
    '../../organization/contacts/group-picker/group-modal.css',
    './assign-tags-modal.component.css',
  ],
})
export class AssignTagsModalComponent implements OnChanges {
  @Input() open: boolean = false;
  @Input() selection: ITag[] = [];
  @Output() close = new EventEmitter();
  @Output() updateSelection = new EventEmitter<ITag[]>();

  // services
  contactService = inject(ContactsService);

  selectedTags: ITag[] = [];

  onPick(items: any[]) {
    this.selectedTags = items as ITag[];
  }

  emitSelection() {
    this.updateSelection.emit([...this.selectedTags]);
    this.closeModal();
  }

  closeModal() {
    this.close.emit();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['open'] || changes['selection']) {
      this.selectedTags = [...(this.selection ?? [])];
    }
  }
}
